<p>customer-product-setup works!</p>
